import { type ComponentProps, type ReactElement, useCallback } from 'react';

import { type Toast, useToast } from '@zillow/constellation-10';

type ToastTone = NonNullable<ComponentProps<typeof Toast>['tone']>;
type EnqueueOptions = Parameters<ReturnType<typeof useToast>['enqueueToast']>[1];

// Warnings and errors stay longer so users have time to read what failed.
export const SPOTLIGHT_TOAST_DURATION_MS: Record<ToastTone, number> = {
  info: 5000,
  success: 5000,
  warning: 8000,
  critical: 8000,
};

export const useSpotlightToast = () => {
  const { enqueueToast } = useToast();
  return useCallback(
    (toast: ReactElement<ComponentProps<typeof Toast>>, options?: EnqueueOptions) =>
      enqueueToast(toast, { duration: SPOTLIGHT_TOAST_DURATION_MS[toast.props.tone ?? 'info'], ...options }),
    [enqueueToast],
  );
};
